import { IconProps, iconA11yProps } from '../types';

export const Chapters = ({ classNames, label }: IconProps) => (
    <svg
        className={classNames}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...iconA11yProps(label)}
    >
        <path d="M11.1965 17L21.2565 17" />
        <path d="M11.1965 12L21.2565 12" />
        <path d="M11.1965 7L21.2565 7" />
        <path d="M3.88013 7.75781L7.76021 12.0005L3.88013 16.2431" />
    </svg>
);
